import { NavLink, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { hasEntitlement, hasAnyEntitlement } from '../../utils/entitlements';
import ServiceIcon from './ServiceIcon';

/**
 * Sidebar nav item: normal route when licensed; otherwise link to Subscriptions with upgrade affordance.
 * @param {{
 *   path: string,
 *   label: string,
 *   icon: import('react').ComponentType<{size?:number,className?:string}>,
 *   service?: string,
 *   anyOf?: string[],
 *   nested?: boolean,
 *   end?: boolean,
 *   isCollapsed?: boolean,
 *   running?: boolean,
 * }} props
 */
export default function ProductSidebarLink({
  path,
  label,
  icon: Icon,
  service,
  anyOf,
  nested,
  end,
  isCollapsed = false,
  running = false,
}) {
  const { user } = useAuth();
  const ok = anyOf?.length
    ? hasAnyEntitlement(user, anyOf)
    : service
      ? hasEntitlement(user, service)
      : true;

  const iconSize = nested ? 18 : 20;
  const baseClass = nested ? 'sidebar-link-nested' : '';

  if (!ok) {
    return (
      <Link
        to="/subscriptions"
        state={{ needLicense: service || anyOf?.[0] }}
        className={`sidebar-link opacity-70 ${baseClass} ${isCollapsed ? 'justify-center px-0' : ''}`}
        title={isCollapsed ? `${label} (Add-on)` : undefined}
        aria-label={`${label} (Add-on)`}
      >
        <ServiceIcon icon={Icon} service={service} size={iconSize} />
        {!isCollapsed && <span className="flex-1 min-w-0 truncate">{label}</span>}
        {!isCollapsed && (
          <span className="text-[10px] font-semibold uppercase tracking-wide text-txnweb-muted shrink-0">
            Add-on
          </span>
        )}
      </Link>
    );
  }

  const runningTitle =
    running && service ? `${label} · job in progress` : isCollapsed ? label : undefined;
  const ariaLabel = running ? `${label} (running)` : label;

  return (
    <NavLink
      to={path}
      className={({ isActive }) =>
        `${isActive ? 'sidebar-link-active' : 'sidebar-link'}${nested ? ' sidebar-link-nested' : ''}${isCollapsed ? ' justify-center px-0' : ''}`
      }
      end={!!end}
      title={runningTitle}
      aria-label={ariaLabel}
    >
      <ServiceIcon icon={Icon} service={service} size={iconSize} running={running} />
      {!isCollapsed && <span>{label}</span>}
    </NavLink>
  );
}
